<template>
  <div :class="[textColor, classes]">{{ text }}</div>
</template>

<script>

import {BRONZE, ORANGE, SILVER} from 'top20common/distribution/constants/tokens';

export default {
  props: {
    text: String,
    type: String,
    classes: {type: String, default: ''}
  },
  data() {
    return {
      textClassesForTokens: {
        [BRONZE]: 'paragraph-dirty-orange',
        [SILVER]: 'paragraph-dark-gray',
        [ORANGE]: 'paragraph-orange'
      }
    };
  },
  computed: {
    textColor() {
      return this.textClassesForTokens[this.type];
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
